import Vue from 'vue'
import Vuex from 'vuex'
import {setCookiesData, removeCookiesData} from '../utils/common'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 用户基本信息
    userBaseInfo: {},
    apiBeforeTime: '' // 登录时的时间
  },
  mutations: {
    getBaseInfo (state, msg) {
      state.userBaseInfo = msg
    },
    getApiBeforeTime (state, msg) {
      state.apiBeforeTime = msg
    },
  },
  actions: {
    // 登录信息
    async GetBaseInfo ({commit}, data) {
      setCookiesData('skyCodeResearchToken', data.token)
      setCookiesData('skyCodeUserBaseInfo', JSON.stringify(data))
      commit('getBaseInfo', {
        userBaseInfo: data
      })
      return true
    },
    // // 左侧菜单
    // async GetNavMenus ({commit}, data) {
    //   setCookiesData('navMenus', JSON.stringify(data))
    //   commit('getNavMenus', {
    //     navMenus: data
    //   })
    //   return true
    // },
    // 退出登录
    async LoginOut ({ commit }) {
      removeCookiesData('skyCodeResearchToken')
      removeCookiesData('skyCodeUserBaseInfo')
      removeCookiesData('skyCodeBeforeTime')
      commit('getBaseInfo', {})
      return true
    }
  },
  modules: {
  }
})
